import React from "react";
import ReactDOMServer from "react-dom/server";
import {
  Form,
  Input,
  Checkbox,
  Row,
  Col,
  Radio,
  DatePicker,
  InputNumber,
  Table,
} from "antd";
import { custDate } from "../../../../commonImports/import1";
import slugify from "slugify";
import AWS from "aws-sdk";
import { configVariables } from "../../../../../configs/configs";
import { questionsVariations } from "../../../../commonImports/data";
import moment from "moment";

const uploadToS3 = () => {
  var s3 = new AWS.S3({ region: configVariables.REGION });
  var params = {
    // Body: <Binary String>,
    Bucket: "examplebucket",
    Key: "HappyFace.jpg",
    ServerSideEncryption: "AES256",
    StorageClass: "STANDARD_IA",
  };
  s3.putObject(params, function (err, data) {
    if (err)
      console.log(err, err.stack); // an error occurred
    else console.log(data); // successful response
    /*
     data = {
      ETag: "\"6805f2cfc46c0f04559748bb039d69ae\"",
      ServerSideEncryption: "AES256",
      VersionId: "CG612hodqujkf8FaaNfp8U..FIhLROcp"
     }
     */
  });
};

/**
 *
 * @param {Object} state - object with original template object and current template object
 * @returns string intrepretation of both objects for comparison
 */
const compareForUnsavedChanges = (state) => {
  // console.log('updated obj', state.demoData)
  let origObjStr = "";
  let stateObj = getDataFromDbForm(state.origObj);
  // console.log('original obj', stateObj);

  origObjStr += stateObj.title;
  if (stateObj.displayName) {
    origObjStr += stateObj.displayName;
  }

  if (stateObj.rows) {
    stateObj.rows.forEach((a) => {
      origObjStr += a.title ? a.title : "";
      a &&
        a != null &&
        a.columns &&
        a.columns.forEach((b) => {
          origObjStr += b.title ? b.title : "";
          b.sections.forEach((c) => {
            // delete c['isEditing']
            origObjStr += c.title ? c.title : "";

            let ss = [];
            c.questions.forEach((e) => {
              if (e && e != null) {
                let pp = { ...e };
                // delete pp['isLinking']
                // delete pp['index']

                let str = "";
                str += pp.isRequired;
                str +=
                  pp.ageFrom +
                  pp.ageTo +
                  pp.appliedFor +
                  pp.helpText +
                  pp.questionTitle +
                  pp.questionType +
                  pp.addNote +
                  pp.addNotApplicable +
                  pp.addPainCalculation +
                  pp.allowToPrint +
                  pp.selectedPainScoreQuestions;
                if (pp.conditions) {
                  str += JSON.stringify(pp.conditions);
                }
                if (pp.number) {
                  str += pp.number.answerSummary;
                }
                if (pp.date) {
                  str += pp.date.answerSummary;
                }
                if (pp.freeText) {
                  str += pp.freeText.answerSummary + pp.freeText.textInputType;
                }
                if (pp.checkboxList) {
                  pp.checkboxList.forEach((a) => {
                    str += a.optionTitle + a.optionSummary;
                  });
                }
                if (pp.radioList) {
                  pp.radioList.forEach((a) => {
                    str += a.optionTitle + a.optionSummary;
                  });
                }
                if (pp.refImage) {
                  str +=
                    pp.refImage.imgUrl.bucket +
                    pp.refImage.imgUrl.key +
                    pp.refImage.imgUrl.region;
                  str +=
                    pp.refImage.areas.lineWidth +
                    pp.refImage.areas.name +
                    pp.refImage.areas.preFillColor +
                    pp.refImage.areas.shape;
                }

                ss.push(str);
              }
            });

            origObjStr += ss.join("");
          });
        });
    });
  }

  let demoObj = "";
  demoObj += state.demoData.title;
  if (state.demoData.displayName) {
    demoObj += state.demoData.displayName;
  }

  if (state.demoData.rows) {
    let kk = [...state.demoData.rows];
    kk.forEach((a) => {
      demoObj += a.title ? a.title : "";
      a &&
        a != null &&
        a.columns &&
        a.columns.forEach((b) => {
          demoObj += b.title ? b.title : "";
          b.sections.forEach((c) => {
            // delete c['isEditing']
            demoObj += c.title ? c.title : "";

            let ss = [];
            c.questions.forEach((e) => {
              if (e && e != null) {
                let pp = { ...e };

                let str = "";
                str += pp.isRequired;
                str +=
                  pp.ageFrom +
                  pp.ageTo +
                  pp.appliedFor +
                  pp.helpText +
                  pp.questionTitle +
                  pp.questionType +
                  pp.addNote +
                  pp.addNotApplicable +
                  pp.addPainCalculation +
                  pp.allowToPrint;
                if (pp.conditions) {
                  str += JSON.stringify(pp.conditions);
                }
                if (pp.number) {
                  str += pp.number.answerSummary;
                }
                if (pp.date) {
                  str += pp.date.answerSummary;
                }
                if (pp.freeText) {
                  str += pp.freeText.answerSummary + pp.freeText.textInputType;
                }
                if (pp.checkboxList) {
                  pp.checkboxList.forEach((a) => {
                    str += a.optionTitle + a.optionSummary;
                  });
                }
                if (pp.radioList) {
                  pp.radioList.forEach((a) => {
                    str += a.optionTitle + a.optionSummary;
                  });
                }
                if (pp.refImage) {
                  str +=
                    pp.refImage.imgUrl.bucket +
                    pp.refImage.imgUrl.key +
                    pp.refImage.imgUrl.region;
                  str +=
                    pp.refImage.areas.lineWidth +
                    pp.refImage.areas.name +
                    pp.refImage.areas.preFillColor +
                    pp.refImage.areas.shape;
                }

                // delete pp['isLinking']
                // delete pp['index']

                ss.push(str);
              }
            });

            demoObj += ss.join("");
          });
        });
    });
  }
  // console.log('original-----',origObjStr)
  // console.log('demo--------',demoObj)
  // console.log(demoObj == origObjStr)
  return {
    origObjStr,
    demoObj,
  };
};

/**
 *
 * @param {Object} demoData - Current template object
 * @returns {Array} templateRows
 * @returns {Array} ques
 * @returns {Array} list
 */
const returnFormattedDemodata = (demoData) => {
  let ques = [];
  let templateRows = [];
  let list = [];

  demoData.rows.forEach((item, i) => {
    if (item && item != null && item.columns.length > 0) {
      // =============
      let ob = {};
      if (item.title) {
        ob.title = item.title;
      }
      if (item.titleConditions) {
        ob.titleConditions = item.titleConditions;
      }
      ob.addColumns = item.addColumns;
      ob.templateColumns = [];
      if (item.pageProperties) {
        ob.pageProperties = item.pageProperties;
      }
      item.columns.forEach((colItem) => {
        if (colItem && colItem != null && colItem.sections.length > 0) {
          // =============
          let obc = {};
          if (colItem.title) {
            obc.title = colItem.title;
          }
          if (colItem.titleConditions) {
            obc.titleConditions = colItem.titleConditions;
          }
          obc.addSection = colItem.addSection;
          obc.columnSections = [];

          colItem.sections.forEach((secItem) => {
            if (secItem && secItem != null && secItem.questions.length > 0) {
              // =============
              let obs = {};
              if (secItem.title) {
                obs.title = secItem.title;
              }
              if (secItem.titleConditions) {
                obs.titleConditions = secItem.titleConditions;
              }
              obs.isEditing = secItem.isEditing;
              obs.secQuestions = [];

              secItem.questions.forEach((qItem) => {
                if (qItem != null && qItem.typeValue == "LONG_TEXT") {
                  obs.secQuestions.push(qItem);
                  return;
                }

                if (qItem != null && qItem.type == "subtemplate") {
                  let obj = {
                    slugValue: qItem.slugValue,
                    title: qItem.title,
                    type: "subtemplate",
                    uId: qItem.uId,
                    queConditions: qItem.conditions.map((condi) => {
                      return {
                        key: condi.key,
                        conditonValue: {
                          quesSlug: condi.value
                            ? condi.value.quesSlug
                            : condi.val.quesSlug,
                          response: condi.value
                            ? condi.value.response
                            : condi.val.response,
                        },
                      };
                    }),
                  };
                  list.push(obj);
                  obs.secQuestions.push(obj);
                  return;
                }

                if (qItem && qItem != null) {
                  list.push(qItem);
                  // =============

                  let obq = {};

                  obq.slugValue = qItem.slugValue;
                  if (qItem.conditions && qItem.conditions.length > 0) {
                    let condi = qItem.conditions[0];
                    let sg = condi.value
                      ? condi.value.quesSlug
                      : condi.val.quesSlug;
                    let rs = condi.value
                      ? condi.value.response
                      : condi.val.response;

                    obq.queConditions = qItem.conditions.map((condi) => {
                      return {
                        key: condi.key,
                        conditonValue: {
                          quesSlug: condi.value
                            ? condi.value.quesSlug
                            : condi.val.quesSlug,
                          response: condi.value
                            ? condi.value.response
                            : condi.val.response,
                        },
                      };
                    });
                    // obq.queConditions = [{
                    //   key: condi.key,
                    //   conditonValue: {
                    //     quesSlug: sg,
                    //     response: rs
                    //   }
                    // }]
                  }
                  if (qItem.attachedVariable) {
                    obq.attachedVariable = qItem.attachedVariable;
                  }

                  if (!ques.includes(`global::question#${qItem.slugValue}`)) {
                    ques.push(`global::question#${qItem.slugValue}`);
                  }

                  obs.secQuestions.push(obq);
                }
              });

              if (obs.secQuestions.length > 0) {
                obc.columnSections.push(obs);
              }
            }
          });
          if (obc.columnSections.length > 0) {
            ob.templateColumns.push(obc);
          }
        }
      });
      if (ob.templateColumns.length > 0) {
        templateRows.push(ob);
      }
    }
  });

  return {
    templateRows,
    ques,
    list,
  };
};

/**
 *
 * @param {Array} ques
 * @param {Object} values
 * @returns {Boolean} flag
 */
const checkConditions = (ques, values) => {
  if (ques != null) {
    let conditions = ques.conditions;
    // let values = form.getFieldsValue();

    let flag = false;

    const loopThroughConditions = (item) => {
      item.children.map((a) => {
        console.log(a);
        setConditionFlag(a);
      });
    };

    const setConditionFlag = (item) => {
      let val = item.val ? item.val : item.value;
      if (Object.keys(values).length > 0) {
        let valuesFlag = undefined;
        for (let valueItem in values) {
          if (valueItem.includes(val.quesSlug)) {
            let substr = valueItem.replace(val.quesSlug, "");
            var reg = new RegExp("^[0-9- ]+$");
            var match = substr.match(reg);
            if (match && substr == match[0]) {
              valuesFlag = values[valueItem];
            }
          }
        }

        if (val && valuesFlag) {
          let demo = questionsVariations.find((x) => {
            if (x.value == val.summary) {
              return x;
            }
          });

          if (demo && demo.value == "<" && valuesFlag.answer <= val.response) {
            flag = true;
          }

          if (demo && demo.value == ">" && valuesFlag.answer >= val.response) {
            flag = true;
          }

          // if (demo == undefined && item.children && item.children.length > 0 && valuesFlag.answer == val.response) {
          //     loopThroughConditions(item)
          // }

          // if (demo == undefined && (item.children== undefined || (item.children && item.children.length == 0) || item.children == null) && valuesFlag.answer == val.response) {
          //     flag = true
          // }
          if (
            demo == undefined &&
            Array.isArray(valuesFlag.answer) &&
            valuesFlag.answer.includes(val.response)
          ) {
            flag = true;
          }
          if (
            demo == undefined &&
            !Array.isArray(valuesFlag.answer) &&
            valuesFlag.answer == val.response
          ) {
            flag = true;
          }
        }
      }
    };
    conditions &&
      conditions.map((item) => {
        // console.log(item)
        // loopThroughConditions(item)
        setConditionFlag(item);
      });
    return flag;
  }
};

const checkConditionsFormSummary = (ques, values, parentquesSlug) => {
  if (ques != null) {
    let conditions = ques.conditions;
    // let values = form.getFieldsValue();

    let flag = false;

    const loopThroughConditions = (item) => {
      item.children.map((a) => {
        console.log(a);
        setConditionFlag(a);
      });
    };

    const setConditionFlag = (item) => {
      let val = item.val ? item.val : item.value;
      if (Object.keys(values).length > 0) {
        let valuesFlag = undefined;
        for (let valueItem in values) {
          if (valueItem.includes(val.quesSlug)) {
            let substr = valueItem.replace(val.quesSlug, "");
            var reg = new RegExp("^[0-9- ]+$");
            var match = substr.match(reg);
            if (match && substr == match[0]) {
              valuesFlag = values[valueItem];
            }
          }
        }

        if (val && valuesFlag) {
          let demo = questionsVariations.find((x) => {
            if (x.value == val.summary) {
              return x;
            }
          });

          if (demo && demo.value == "<" && valuesFlag.answer <= val.response) {
            flag = true;
          }

          if (demo && demo.value == ">" && valuesFlag.answer >= val.response) {
            flag = true;
          }

          // if (demo == undefined && item.children && item.children.length > 0 && valuesFlag.answer == val.response) {
          //     loopThroughConditions(item)
          // }

          // if (demo == undefined && (item.children== undefined || (item.children && item.children.length == 0) || item.children == null) && valuesFlag.answer == val.response) {
          //     flag = true
          // }
          if (
            demo == undefined &&
            Array.isArray(valuesFlag.answer) &&
            valuesFlag.answer.includes(val.response)
          ) {
            flag = true;
          }
          if (
            demo == undefined &&
            !Array.isArray(valuesFlag.answer) &&
            valuesFlag.answer == val.response
          ) {
            flag = true;
          }
        }
      }
    };
    conditions &&
      conditions.map((item) => {
        let val = item.val ? item.val : item.value;
        // loopThroughConditions(item)
        if (parentquesSlug == val.quesSlug) {
          setConditionFlag(item);
        }
      });
    return flag;
  }
};

/**
 *
 * @param {Object} itemValidation - Validation object
 * @param {Object} query - Query Instance
 * @returns {Boolean} - Flag
 */
const checkValidation = (itemValidation, query) => {
  let flag = true;
  let validation = {};
  if (validation && itemValidation && query) {
    if (query.has("age") == true) {
      validation.age = parseInt(query.get("age"));
    }
    if (query.has("gender") == true) {
      validation.gender = query.get("gender");
    }

    if (
      validation.age &&
      Object.keys(validation).length > 0 &&
      itemValidation.ageFrom &&
      itemValidation.ageFrom != null &&
      validation.age < itemValidation.ageFrom
    ) {
      flag = false;
    }

    if (
      validation.age &&
      Object.keys(validation).length > 0 &&
      itemValidation.ageTo &&
      itemValidation.ageTo != null &&
      validation.age > itemValidation.ageTo
    ) {
      flag = false;
    }

    if (
      validation.gender &&
      Object.keys(validation).length > 0 &&
      itemValidation.gender &&
      itemValidation.gender != null &&
      validation.gender.trim().toLowerCase() !=
        itemValidation.gender.trim().toLowerCase()
    ) {
      flag = false;
    }
  }
  return flag;
};

const getItemValidation = (item) => {
  // return age gender validation conditions
  let itemValidation = {};
  if (item.ageFrom != null) {
    itemValidation.ageFrom = item.ageFrom;
  }
  if (item.ageTo != null) {
    itemValidation.ageTo = item.ageTo;
  }
  if (item.appliedFor != null) {
    itemValidation.gender = item.appliedFor;
  }
  return itemValidation;
};

const renderSymmaryHtmlFragment = (
  flag = undefined,
  inline = false,
  text,
  summary,
  answer,
  voiceNote,
) => {
  //  console.log(flag, text, summary, answer, voiceNote)
  // answer is optional - only for free text, number, file, date;
  // if(inline == true){
  //   let str = '';
  //   if(text && !answer){
  //     str += `<span style='margin-bottom:0px'>${text}, </span>`;
  //   }
  //   if (!text && answer) {
  //     str += `<span style='margin-bottom:0px'>${answer}, </span>`
  //   }
  //   if (text && answer) {
  //       str += `<span style='margin-bottom:0px'>${text} : ${answer} </span>`
  //   }
  //   if (summary) {
  //       str += `<span><span style='font-weight:600;margin-bottom:0px;'>Note: </span>${summary} </span>`
  //   }
  //   if(voiceNote){
  //     str+= `<audio controls src="${voiceNote instanceof Blob ? window.URL.createObjectURL(voiceNote) : voiceNote}"></audio>`
  //   }
  //   // if(flag == undefined && (text || summary || answer || voiceNote)){
  //   //   str = `</div>${str}<div class="block" style="border:1px solid grey;margin-left:10px">`
  //   // }

  //   return str;
  // }

  // let str = `<div style="${flag == undefined && (text || summary || answer || voiceNote) ? '' : 'margin-left:10px'}">`;
  let str = "";
  if (text && !answer) {
    str += `<p style='margin-bottom:0px'>${text} &nbsp;</p>`;
  }
  if (!text && answer) {
    str += `<p style='margin-bottom:0px'>${answer} &nbsp;</p>`;
  }
  if (text && answer) {
    str += `<p style='margin-bottom:0px'>${text} : ${answer} &nbsp;</p>`;
  }
  if (summary) {
    str += `<p style='margin-bottom:0px; margin-left:10px'><span style='font-weight:600;margin-bottom:0px;'> Note: </span>${summary} &nbsp;</p>`;
  }
  if (voiceNote) {
    // str+= `<audio controls src="${voiceNote instanceof Blob ? window.URL.createObjectURL(voiceNote) : voiceNote}"></audio> &nbsp;`
    str += `<audio controls style='width:132px; height:10px'>
	<source src="${voiceNote instanceof Blob ? window.URL.createObjectURL(voiceNote) : voiceNote}">
</audio> &nbsp;`;
  }
  // if(flag == undefined && (text || summary || answer || voiceNote)){
  //   str = `</div>${str}<div class="block" style="border:1px solid grey;margin-left:10px">`
  // }
  // str+= '</div>'

  return str;
};

const renderSymmaryStringFragment = (
  flag = undefined,
  flag3,
  text,
  summary,
  answer,
  voiceNote,
) => {
  // console.log(text, summary)
  let str = "";
  let flag2 = undefined;
  if (flag == undefined && (text || summary || answer || voiceNote)) {
    flag2 = true;
  }

  if (text && !answer) {
    str += `${text}`;
  }
  if (!text && answer) {
    str += `${answer}`;
  }
  if (text && answer) {
    str += `${text} : ${answer}`;
  }
  if (summary) {
    str += `Note: ${summary}`;
  }
  if (voiceNote) {
    str += ` Voice Note: ${voiceNote instanceof Blob ? "" : voiceNote}`;
  }
  return str;
};

const getQuesSummery = (item, flag = undefined, values) => {
  let htmlStr2 = "";
  let str2 = "";

  if (item != null) {
    let name = item.slugValueNew;
    let ans = values[name];

    // Get question title for including in summary
    let questionTitle = item.questionTitle || "";

    if (ans && item.questionType == "CHECK_BOX") {
      let ansArr = item.checkboxList;
      if (ans.answer) {
        // Collect all selected answers
        let selectedAnswers = ans.answer
          .map((p) => {
            let obj = ansArr.find((x) => x.optionTitle == p);
            if (obj) {
              return obj.optionSummary && obj.optionSummary.trim()
                ? obj.optionSummary
                : obj.optionTitle;
            }
            return p;
          })
          .filter(Boolean);

        // Create summary with question title and answers
        let answerText = selectedAnswers.join(", ");
        let fullText = questionTitle
          ? `${questionTitle}: ${answerText}`
          : answerText;

        htmlStr2 += renderSymmaryHtmlFragment(
          flag,
          false,
          fullText,
          ans.summary,
          undefined,
          ans.voiceNote,
        );
        str2 += renderSymmaryStringFragment(
          flag,
          false,
          fullText,
          ans.summary,
          undefined,
          ans.voiceNote,
        );
      }
    }
    //done
    if (ans && item.questionType == "RADIO_BUTTON") {
      let ansArr = item.radioList;
      let obj = ansArr.find((x) => x.optionTitle == ans.answer);
      // Use optionSummary if it has meaningful content, otherwise fall back to optionTitle (the answer)
      let answerText = "";
      if (obj) {
        answerText =
          obj.optionSummary && obj.optionSummary.trim()
            ? obj.optionSummary
            : obj.optionTitle;
      } else {
        answerText = ans.answer || "";
      }

      // Create full text with question title
      let fullText = questionTitle
        ? `${questionTitle}: ${answerText}`
        : answerText;

      htmlStr2 += renderSymmaryHtmlFragment(
        flag,
        false,
        fullText,
        ans.summary,
        undefined,
        ans.voiceNote,
      );
      str2 += renderSymmaryStringFragment(
        flag,
        false,
        fullText,
        ans.summary,
        undefined,
        ans.voiceNote,
      );
    }
    //done
    if (
      (ans && item.questionType == "SINGLE_LINE") ||
      (ans && item.questionType == "MULTI_LINE") ||
      (ans && item.questionType == "FREE_TEXT")
    ) {
      let ansText = item.freeText;
      let ansSum =
        (ans.summary && ans.answer) ||
        (ans.answer && ans.answer != undefined) ||
        (ans.summary && ans.summary != undefined)
          ? ansText.answerSummary
          : "";

      // Prepend question title if available
      let fullText = questionTitle ? `${questionTitle}` : ansSum;

      htmlStr2 += renderSymmaryHtmlFragment(
        flag,
        false,
        fullText,
        ans.summary,
        ans.answer,
        ans.voiceNote,
      );
      str2 += renderSymmaryStringFragment(
        flag,
        false,
        fullText,
        ans.summary,
        ans.answer,
        ans.voiceNote,
      );
    }

    if (ans && item.questionType == "FILL_IN_BLANKS") {
      const regex = /[_]+/g;
      // elem = <h1>{p.fillInBlanks.answerSummary.replaceAll(regex,'<h1>'+regex+'</h1>')}</h1>
      let arr = item.fillInBlanks.answerSummary.split(regex);

      let ansSum = "";
      arr.map((a, i) => {
        ansSum += a;
        if (i != arr.length - 1) {
          ansSum += ans.answer[i] ? ans.answer[i] : "-";
        }
      });

      // Prepend question title if available
      let fullText = questionTitle ? `${questionTitle}: ${ansSum}` : ansSum;

      htmlStr2 += renderSymmaryHtmlFragment(
        flag,
        false,
        fullText,
        ans.summary,
        undefined,
        ans.voiceNote,
      );
      str2 += renderSymmaryStringFragment(
        flag,
        false,
        fullText,
        ans.summary,
        undefined,
        ans.voiceNote,
      );
    }
    //done
    if (ans && item.questionType == "NUMBER") {
      let ansText = item.number;
      let ansSum =
        (ans.summary && ans.answer) ||
        (ans.answer && ans.answer != undefined) ||
        (ans.summary && ans.summary != undefined)
          ? ansText.answerSummary
          : "";

      // Prepend question title if available
      let fullText = questionTitle ? `${questionTitle}` : ansSum;

      htmlStr2 += renderSymmaryHtmlFragment(
        flag,
        false,
        fullText,
        ans.summary,
        ans.answer,
        ans.voiceNote,
      );
      str2 += renderSymmaryStringFragment(
        flag,
        false,
        fullText,
        ans.summary,
        ans.answer,
        ans.voiceNote,
      );
    }
    //done
    if (ans && item.questionType == "FILE") {
      let ansText = item.file;
      let ansSum =
        (ans.summary && ans.answer) ||
        (ans.answer && ans.answer != undefined) ||
        (ans.summary && ans.summary != undefined)
          ? ansText.answerSummary
          : "";

      // Prepend question title if available
      let fullText = questionTitle ? `${questionTitle}` : ansSum;

      htmlStr2 += renderSymmaryHtmlFragment(
        flag,
        false,
        fullText,
        ans.summary,
        ans.answer,
        ans.voiceNote,
      );
      str2 += renderSymmaryStringFragment(
        flag,
        false,
        fullText,
        ans.summary,
        ans.answer,
        ans.voiceNote,
      );
    }
    //done
    if (ans && item.questionType == "DATE") {
      let ansText = item.date;
      let ansSum =
        (ans.summary && ans.answer) ||
        (ans.answer && ans.answer != undefined) ||
        (ans.summary && ans.summary != undefined)
          ? ansText.answerSummary
          : "";
      let dd = ans.answer ? moment(ans.answer).format("YYYY-MM-DD") : undefined;

      // Prepend question title if available
      let fullText = questionTitle ? `${questionTitle}` : ansSum;

      htmlStr2 += renderSymmaryHtmlFragment(
        flag,
        false,
        fullText,
        ans.summary,
        dd,
        ans.voiceNote,
      );
      str2 += renderSymmaryStringFragment(
        flag,
        false,
        fullText,
        ans.summary,
        dd,
        ans.voiceNote,
      );
    }

    if (item.questionType == "TABLE") {
      // Prepend question title for table
      let tableTitle = questionTitle
        ? `<p style='font-weight:600;margin-bottom:5px;'>${questionTitle}</p>`
        : "";
      let tableTitleStr = questionTitle ? `${questionTitle}\n` : "";

      let htmlString =
        tableTitle +
        ReactDOMServer.renderToStaticMarkup(
          renderTableAnsResponse(item, values, "html"),
        );
      let str =
        tableTitleStr +
        ReactDOMServer.renderToStaticMarkup(
          renderTableAnsResponse(item, values, "str"),
        );
      if (ans.summary) {
        str += ` Note: ${ans.summary}`;
        htmlString += `<br/><p style='margin-bottom:0px; margin-left:10px'><span style='font-weight:600;margin-bottom:0px;'> Note: </span>${ans.summary} &nbsp;</p>`;
      }
      if (ans.voiceNote) {
        str += "\n";
        str += `  ${ans.voiceNote}`;
      }
      str += "\n";

      htmlStr2 += htmlString;
      str2 += str;
    }
  }
  return {
    htmlStr2,
    str2,
  };
};

const getQuesSummeryForPrint = (item, ans) => {
  var questionType =
    item.questionType == "SINGLE_LINE" ||
    item.questionType == "MULTI_LINE" ||
    item.questionType == "FREE_TEXT"
      ? "FREE_TEXT"
      : item.questionType;
  switch (questionType) {
    case "FREE_TEXT":
      return item.freeText && item.freeText.answerSummary
        ? item.freeText.answerSummary
        : "";

    case "NUMBER":
      return item.number && item.number.answerSummary
        ? item.number.answerSummary
        : "";

    case "DATE":
      return item.date && item.date.answerSummary
        ? item.date.answerSummary
        : "";

    case "FILL_IN_BLANKS":
      return item.fillInBlanks && item.fillInBlanks.answerSummary
        ? item.fillInBlanks.answerSummary
        : "";

    case "FILE":
      return item.file && item.file.answerSummary
        ? item.file.answerSummary
        : "";

    case "RADIO_BUTTON":
      let ansArr = item.radioList;
      let obj = ansArr.find(
        (x) => x.optionTitle == ans.answer || x.optionSummary == ans.answer,
      );
      return obj.optionSummary;

    case "CHECK_BOX":
      let summary1 = "";
      if (ans.answer) {
        ans.answer.forEach((p) => {
          let obj = item.checkboxList.find((x) => x.optionTitle == p);

          summary1 += obj.optionSummary + ".";
        });
      }
      return summary1;
    default: {
      var summary = "";

      return summary;
    }
  }
};

/**
 *
 * @param {Array} list
 * @param {Object} values
 * @returns {String} htmlStr - Html summary
 * @returns {String} str - String summary
 */
const getSummaryFromData = (list, values) => {
  var htmlStr = "";
  var str = "";
  var htmlOnlyFilled = "";
  let newObj = {};

  const findParentQuestion = (item, obj) => {
    for (const iterator in obj) {
      let conditionsValue = item.conditions[0].value
        ? item.conditions[0].value
        : item.conditions[0].val;
      if (obj[iterator].children.hasOwnProperty(conditionsValue.quesSlug)) {
        for (const iterator2 in obj[iterator].children) {
          if (iterator2 == conditionsValue.quesSlug) {
            let obj2 = getQuesSummery(item, false, values);
            obj[iterator].children[iterator2]["children"][item.slugValue] = {};
            obj[iterator].children[iterator2]["children"][
              item.slugValue
            ].summery = obj2;
            obj[iterator].children[iterator2]["children"][
              item.slugValue
            ].children = {};
          }
        }
      } else {
        findParentQuestion(item, obj[iterator].children);
      }
    }
  };

  list.filter((a) => {
    let aa = { ...values };
    // if(a.questionType=="TABLE")
    // {
    //   aa['table-0-0-0-1'].answer=aa.table
    // }
    if (
      aa.hasOwnProperty(a.slugValueNew) &&
      Object.values(aa[a.slugValueNew]).filter((a) => a != undefined).length > 0
    ) {
      if (a.questionType == "TABLE") {
        let tableVal = aa[a.slugValueNew];
        let flag = false;
        for (const property in tableVal) {
          // if(property!="summary" && property!="answer" && tableVal[property] && tableVal[property].answer){
          //   console.log("tableVal[property].answer",tableVal[property].answer)

          // }

          // if((property=="summary" && tableVal[property]==undefined) ||(property && property!="summary" && tableVal[property] && tableVal[property].answer==undefined)){
          //       return
          // }

          if (
            property &&
            property != "summary" &&
            tableVal[property] &&
            tableVal[property].answer != undefined
          ) {
            flag = true;
            // return
          }
        }
        if (flag == false) {
          return;
        }
      }
      if (a.conditions) {
        // console.log("in filter",a)
        let conditionsValue = a.conditions[0].value
          ? a.conditions[0].value
          : a.conditions[0].val;
        if (newObj.hasOwnProperty(conditionsValue.quesSlug)) {
          let obj = getQuesSummery(a, false, aa);
          newObj[conditionsValue.quesSlug]["children"][a.slugValue] = {};
          newObj[conditionsValue.quesSlug]["children"][a.slugValue].summery =
            obj;
          newObj[conditionsValue.quesSlug]["children"][a.slugValue].children =
            {};
        } else {
          findParentQuestion(a, newObj);
        }
        return a;
      } else {
        // console.log("in filter",a)
        let obj = getQuesSummery(a, false, aa);
        newObj[a.slugValue] = {};
        newObj[a.slugValue]["summery"] = obj;
        newObj[a.slugValue]["children"] = {};
        // arr.push(a)
      }
    }
  });

  // console.log(newObj)
  const spaceFun = (x) => {
    // console.log(x)
    let str = "";
    for (let i = 1; i <= x; i++) str += "\xa0\xa0\xa0";
    return str;
  };

  const getSummery = (obj, x) => {
    if (Object.keys(obj.children).length > 0) {
      htmlStr += `<div style="margin-left:${20 * x}px; display:flex;"><span style="margin-right:5px">&#8226;</span>${obj.summery.htmlStr2}</div>`;
      htmlOnlyFilled += `${obj.summery.htmlStr2}`;
      str += spaceFun(x) + obj.summery.str2 + "\n";
      x = x + 1;
      Object.keys(obj.children).map((a) => {
        getSummery(obj.children[a], x);
      });
    } else {
      htmlStr += `<div style="margin-left:${20 * x}px; display:flex;"><span style="margin-right:5px">&#9675;</span>${obj.summery.htmlStr2}</div>`;
      htmlOnlyFilled += `${obj.summery.htmlStr2}`;
      str += spaceFun(x) + obj.summery.str2 + "\n";
    }
  };

  Object.values(newObj).map((a) => {
    getSummery(a, 0);
    htmlStr += '<div style="padding:5px"></div>';
  });

  // const findNextQues=(arr, item=undefined)=>{
  //   let a = arr.filter((item2, x)=>{
  //     if(values[item2.slugValueNew]){
  //       if(checkConditionsFormSummary(item2, values, item ? item.slugValue : item2.slugValue)){
  //         let obj2 = getQuesSummery(item2, true, values)
  //         htmlStr += obj2.htmlStr2;
  //         str += obj2.str2;
  //         // arr2.splice(x,1);
  //         findNextQues(arr, item2)
  //         return item2
  //       }
  //     }
  //   })
  //   // console.log('in if', a)
  //   // if(a.length > 0 ){
  //   //   findNextQues(a)
  //   // }
  // }

  // arr.forEach((item) => {
  //   if(values[item.slugValueNew]){
  //     let obj = getQuesSummery(item, undefined, values)
  //     htmlStr += obj.htmlStr2;
  //     str += obj.str2;
  //     findNextQues(arr2, item)
  //   }
  // });

  return {
    htmlStr,
    str,
    htmlOnlyFilled,
  };
};

// const getSummaryFromData=(list, values)=>{
//   console.time('doSomething')
//   var htmlStr = '';
//   var str = '';

//   let arr = [];
//   let arr2 = list.filter((a)=>{
//     if(a.conditions){
//       return a
//     }else{
//       arr.push(a)
//     }
//   });

//   list.map((item) => {
//         let obj = getQuesSummery(item, undefined, values, item.conditions ? true : undefined)
//         htmlStr += obj.htmlStr2;
//         str += obj.str2;
//       // arr2.map((item2)=>{
//       //   if(checkConditionsFormSummary(item2, values, item.slugValue)){
//       //     let obj2 = getQuesSummery(item2, true, values)
//       //     htmlStr += obj2.htmlStr2;
//       //     str += obj2.str2;
//       //   }
//       // })
//   });
//   console.timeEnd('doSomething')
//   return {
//     htmlStr,
//     str
//   }
// }

const renderTableAnsResponse = (main, values, val) => {
  let p = null;
  if (main.tableValues && main.tableValues != null) {
    try {
      p = JSON.parse(main.tableValues)["json"];
    } catch (err) {
      p = main.tableValues.json;
    }
  }
  if (p == null) {
    return null;
  }
  p.slugValueNew = main.slugValueNew;
  p.table.map((itemT, i) => {
    itemT.map((itemR, j) => {
      if (values[p.slugValueNew] && values[p.slugValueNew][`${j}${i}`]) {
        itemR.answerValue = values[p.slugValueNew][`${j}${i}`];
      } else {
        itemR.answerValue = "-";
      }
    });
  });
  main.tableValues = JSON.stringify({ json: p });
  if (val == "str") {
    return returnTable1(main, null, null);
  } else {
    return returnTable(main, null, null);
  }

  let lWidth = 100 / (p.columnHeaders.length + 1) + "%";

  return (
    <div>
      {p.summary}
      <div className="layout-table">
        <div className="layout-header">
          {p.rowHeaders && p.rowHeaders != null && (
            <div
              className="layout-column layout-cell-padding"
              style={{ width: lWidth }}
            ></div>
          )}
          {p.columnHeaders.map((p) => {
            return (
              <div
                className="layout-column"
                style={{ fontWeight: "600", width: lWidth, padding: "10px" }}
              >
                {p}
              </div>
            );
          })}
        </div>

        {p.rowHeaders && (
          <div
            className="layout-column"
            style={{ width: lWidth, fontWeight: "600" }}
          >
            {Array.apply(null, Array(p.rowsCount)).map((item, i) => {
              return (
                <div className="layout-cell layout-cell-padding">
                  {" "}
                  {p.rowHeaders && p.rowHeaders[i] ? p.rowHeaders[i] : ""}
                </div>
              );
            })}
          </div>
        )}
        {p.table.map((item, i) => {
          return (
            <>
              <div className="layout-column" style={{ width: lWidth }}>
                {item.map((itemR, k) => {
                  if (itemR) {
                    return (
                      <>
                        <div className="layout-cell layout-cell-padding">
                          {values[itemR.slugValue] &&
                          values[itemR.slugValue].answer
                            ? itemR.questionType == "DATE"
                              ? custDate(values[itemR.slugValue].answer)
                              : values[itemR.slugValue].answer
                            : "-"}
                        </div>
                      </>
                    );
                  }
                })}
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

const replacePlaceholders = (template, values) => {
  values.forEach((obj) => {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const placeholder = `${key}`;
        const value = obj[key];

        // Use a regular expression to replace all occurrences of the placeholder
        const regex = new RegExp(placeholder, "g");
        template = template.replace(regex, value);
      }
    }
  });
  return template;
};

/**
 *
 * @param {Object} data - Template object from database
 * @returns {Object} - Template Object in local format
 */
const getDataFromDbForm = (data, paramsList = []) => {
  let arr = [];
  if (data.attachedQuestionRefs) {
    arr = [...data.attachedQuestionRefs];
  }
  let arrsubtemplate = [];
  if (data.attachedSubtemplateRef) {
    arrsubtemplate = [...data.attachedSubtemplateRef];
  }

  if (arr.length > 0) {
    let obj = {
      title: data.templateName,
      displayName: data.displayName,

      // description: 'form description',
      active: data.active,
      slugValue: data.slugValue
        ? data.slugValue
        : slugify(data.templateName.trim(), {
            lower: true,
          }),
    };
    if (data.customVariables) {
    }

    if (
      (!data.templateDesignJson || data.templateDesignJson == null) &&
      data.templateRows
    ) {
      obj.rows = data.templateRows.map((item) => {
        return {
          title: item.title,
          addColumns: item.addColumns,
          pageProperties: item.pageProperties,
          columns: item.templateColumns.map((colItem) => {
            return {
              title: colItem.title,
              addSection: colItem.addSection,
              sections: colItem.columnSections.map((secItem) => {
                return {
                  title: secItem.title,
                  isEditing: secItem.isEditing,
                  questions: secItem.secQuestions.map((quesItem) => {
                    if (quesItem && quesItem != null) {
                      if (
                        quesItem != null &&
                        quesItem.typeValue == "LONG_TEXT"
                      ) {
                        return quesItem;
                      }

                      let qObj = arr.find(
                        (aa) =>
                          aa &&
                          aa != null &&
                          aa.slugValue == quesItem.slugValue,
                      );

                      if (qObj && quesItem.attachedVariable) {
                        qObj.attachedVariable = quesItem.attachedVariable;
                      }

                      if (qObj && quesItem.queConditions != null) {
                        qObj.conditions = quesItem.queConditions.map((x) => {
                          let mm = arr.find(
                            (aa) =>
                              aa &&
                              aa != null &&
                              aa.slugValue == x.conditonValue.quesSlug,
                          );

                          if (mm) {
                            return {
                              key: x.key,
                              title: `${mm.questionTitle} ${x.conditonValue.response}`,
                              value: x.conditonValue,
                              children: null,
                            };
                          } else {
                            return {
                              key: x.key,
                              title: "question",
                              value: x.conditonValue,
                              children: null,
                            };
                          }
                        });
                        // return qObj
                      }
                      if (qObj && quesItem.queConditions == null) {
                      }
                      var updatedHelpText = null;
                      if (qObj.helpText && qObj.helpText !== null) {
                        //pawarchng
                        updatedHelpText = replacePlaceholders(
                          qObj.helpText,
                          paramsList,
                        );
                        qObj.helpText = updatedHelpText;
                      }
                      return qObj;
                    }
                  }),
                };
              }),
            };
          }),
        };
      });
    }
    if (data.templateDesignJson && data.templateDesignJson != null) {
      let parsedObj = null;
      try {
        parsedObj = JSON.parse(data.templateDesignJson);
      } catch (err) {
        parsedObj = data.templateDesignJson;
      }

      if (parsedObj.properties) {
        obj.properties = parsedObj.properties;
      }

      if (data.customVariables) {
        obj.properties = obj.properties ? obj.properties : {};
        obj.properties.variables = data.customVariables["variables"];
      }

      obj.rows = parsedObj["json"].map((item, rowIndex) => {
        return {
          title: item.title,
          titleConditions: item.titleConditions,
          addColumns: item.addColumns,
          pageProperties: item.pageProperties,
          columns: item.templateColumns.map((colItem, colIndex) => {
            return {
              title: colItem.title,
              titleConditions: colItem.titleConditions,
              addSection: colItem.addSection,
              sections: colItem.columnSections.map((secItem, secIndex) => {
                return {
                  title: secItem.title,
                  titleConditions: secItem.titleConditions,
                  isEditing: secItem.isEditing,
                  questions: secItem.secQuestions.map((quesItem, quesIndex) => {
                    if (quesItem && quesItem != null) {
                      if (
                        quesItem != null &&
                        quesItem.typeValue == "LONG_TEXT"
                      ) {
                        return quesItem;
                      }
                      if (quesItem.type && quesItem.type == "subtemplate") {
                        let ss = arrsubtemplate.find(
                          (aa) =>
                            aa &&
                            aa != null &&
                            aa.slugValue == quesItem.slugValue,
                        );
                        let subObj = {};
                        if (ss) {
                          subObj = { ...ss };
                          subObj.type = "subtemplate";

                          let objss = getDataFromDbForm(ss);
                          let arrss = ss.attachedQuestionRefs;
                          let arrmm = [];

                          objss.rows.map((a, i) => {
                            a.columns.map((b, j) => {
                              b.sections.map((c, k) => {
                                c.questions.map((d, l) => {
                                  let indexss = arrss.findIndex(
                                    (v) => v.slugValue == d.slugValue,
                                  );
                                  if (indexss > -1) {
                                    d.slugValueNew = `${d.slugValue}-${i}-${j}-${k}-${l}-${quesIndex}`;
                                    d.conditions = quesItem.conditions;
                                    arrmm.push(d);
                                  }
                                });
                              });
                            });
                          });
                          subObj.attachedQuestionRefs = arrmm;
                        }

                        subObj.conditions = quesItem.queConditions.map((x) => {
                          let jj = arrsubtemplate.find(
                            (aa) =>
                              aa &&
                              aa != null &&
                              aa.slugValue == x.conditonValue.quesSlug,
                          );
                          let mm = { ...jj };

                          if (mm) {
                            return {
                              key: x.key,
                              title: `${mm.questionTitle} ${x.conditonValue.response}`,
                              value: x.conditonValue,
                              children: null,
                            };
                          } else {
                            return {
                              key: x.key,
                              title: "question",
                              value: x.conditonValue,
                              children: null,
                            };
                          }
                        });

                        delete subObj["queConditions"];
                        return subObj;
                      }

                      let kk = arr.find(
                        (aa) =>
                          aa &&
                          aa != null &&
                          aa.slugValue == quesItem.slugValue,
                      );

                      if (!kk) {
                        if (quesItem.queConditions) {
                          quesItem.conditions = quesItem.queConditions.map(
                            (x) => {
                              let jj = arr.find(
                                (aa) =>
                                  aa &&
                                  aa != null &&
                                  aa.slugValue == x.conditonValue.quesSlug,
                              );
                              let mm = { ...jj };
                              if (mm) {
                                return {
                                  key: x.key,
                                  title: `${mm.questionTitle} ${x.conditonValue.response}`,
                                  value: x.conditonValue,
                                  children: null,
                                };
                              } else {
                                return {
                                  key: x.key,
                                  title: "question",
                                  value: x.conditonValue,
                                  children: null,
                                };
                              }
                            },
                          );
                          delete quesItem["queConditions"];
                        }
                        return quesItem;
                      }
                      let qObj = { ...kk };
                      var updatedHelpText = null;
                      if (qObj.helpText && qObj.helpText !== null) {
                        updatedHelpText = replacePlaceholders(
                          qObj.helpText,
                          paramsList,
                        );
                        qObj.helpText = updatedHelpText;
                      }
                      qObj.slugValueNew = `${qObj.slugValue}-${rowIndex}-${colIndex}-${secIndex}-${quesIndex}`;
                      if (qObj && quesItem.attachedVariable) {
                        qObj.attachedVariable = quesItem.attachedVariable;
                      }

                      if (
                        qObj &&
                        quesItem.queConditions &&
                        quesItem.queConditions != null
                      ) {
                        qObj.conditions = quesItem.queConditions.map((x) => {
                          let jj = arr.find(
                            (aa) =>
                              aa &&
                              aa != null &&
                              aa.slugValue == x.conditonValue.quesSlug,
                          );
                          let mm = { ...jj };
                          if (mm) {
                            return {
                              key: x.key,
                              title: `${mm.questionTitle} ${x.conditonValue.response}`,
                              value: x.conditonValue,
                              children: null,
                            };
                          } else {
                            return {
                              key: x.key,
                              title: "question",
                              value: x.conditonValue,
                              children: null,
                            };
                          }
                        });
                        return qObj;
                      }

                      if (qObj && !quesItem.queConditions) {
                        return qObj;
                      }
                    }
                  }),
                };
              }),
            };
          }),
        };
      });
    }

    // let obj = {
    //   title: data.templateName,
    //   // description: 'form description',
    //   active: data.active,
    //   rows: data.templateRows.map((item)=>{
    //     return{
    //       title: item.title,
    //       addColumns: item.addColumns,
    //       columns: item.templateColumns.map((colItem)=>{
    //         return{
    //           title: colItem.title,
    //           addSection: colItem.addSection,
    //           sections: colItem.columnSections.map((secItem)=>{
    //             return{
    //               title: secItem.title,
    //               isEditing: secItem.isEditing,
    //               questions: secItem.secQuestions.map((quesItem)=>{
    //                 let qObj = arr.find((aa)=>aa && aa != null && aa.slugValue== quesItem.slugValue);
    //                 if(qObj && quesItem.queConditions != null){
    //                   qObj.conditions = quesItem.queConditions.map((x)=>{
    //                     let mm = arr.find((aa)=>aa && aa != null && aa.slugValue== x.conditonValue.quesSlug);

    //                     if(mm){
    //                       return {
    //                         key : x.key,
    //                         title: `${mm.questionTitle} ${x.conditonValue.response}`,
    //                         value: x.conditonValue,
    //                         children: null
    //                       }
    //                     }else{
    //                       return {
    //                         key : x.key,
    //                         title: 'question',
    //                         value: x.conditonValue,
    //                         children: null
    //                       }
    //                     }
    //                   });
    //                   return qObj
    //                 }
    //                 if(qObj && quesItem.queConditions == null){
    //                   return qObj
    //                 }

    //               })
    //             }
    //           })
    //         }
    //       })
    //     }
    //   })
    // }
    return obj;
  }
};

/**
 *
 * @param {Object} main
 * @param {Object} props
 * @param {Object} answers
 * @returns - Table Component
 */
const returnTable1 = (main, props, answers) => {
  let p = null;
  if (main.tableValues && main.tableValues != null) {
    try {
      p = JSON.parse(main.tableValues)["json"];
    } catch (err) {
      p = main.tableValues.json;
    }
  } else if (main.columnHeaders) {
    p = main;
  }

  if (p == null) {
    return null;
  }

  let dataSource = p.table.map((a, i) => {
    let obj = new Object();

    a.map((c, j) => {
      if (c) {
        c.index = `${j}${i}`;
      }
      let colTitle = p.columnHeaders[j];
      if (colTitle) {
        obj[colTitle] = c;
      }
    });
    if (p.rowHeaders && p.rowHeaders[i]) {
      obj["rowHeader"] = p.rowHeaders[i];
    }
    return obj;
  });
  let arr = [],
    obj = {};
  dataSource.length > 0 &&
    dataSource.map((val, ind) => {
      obj["rowHeader"] = val.rowHeader;
      for (const [key, value] of Object.entries(val)) {
        if (key && value.answerValue != null) {
          if (key != "rowHeader") {
            obj[key] =
              value && value.answerValue && value.answerValue.answer
                ? value.answerValue.answer
                : "-";
          }
        }
      }
      arr.push(obj);
      obj = {};
    });
  let str = "";

  arr.length > 0 &&
    arr.map((i, j) => {
      for (const [key, value] of Object.entries(i)) {
        var keyArr = Object.keys(i);
        //   console.log(keyArr, "karrrrrrrrrrr");

        // var addToStringFlag= false;
        const hasNonDashValueFlag = Object.entries(i).some(
          ([key, value]) => key !== "rowHeader" && value !== "-",
        );

        if (hasNonDashValueFlag == true) {
          if (key == "rowHeader") {
            //   console.log(key, value, "rtttttttttttttttt");

            if (value !== undefined && value !== "-") {
              const isDate = moment(value, moment.ISO_8601, true).isValid();
              // console.log(isDate, "isdddddddddddd");

              if (isDate) {
                str += moment(value).format("YYYY-MM-DD") + "\n";
              } else {
                str += value + "\n";
              }
            }
          } else {
            //   console.log(key, value, "keyyyyyyyyyyyy");
            if (value !== "-") {
              const isDate1 = moment(value, moment.ISO_8601, true).isValid();
              // console.log(isDate1, "ddddddddd111111");

              if (isDate1) {
                str +=
                  "\xa0\xa0" +
                  key +
                  " : " +
                  moment(value).format("YYYY-MM-DD") +
                  "\n";
              } else {
                str += "\xa0\xa0" + key + " : " + value + "\n";
              }
            }
          }
        }
      }
    });

  return str;
  // return <Table size="small" dataSource={dataSource} columns={columns} pagination={false}/>
};

/**
 *
 * @param {Object} main
 * @param {Object} props
 * @param {Object} answers
 * @returns Table Component
 */
const returnTable = (main, props, answers) => {
  let p = null;
  if (main.tableValues && main.tableValues != null) {
    try {
      p = JSON.parse(main.tableValues)["json"];
    } catch (err) {
      p = main.tableValues.json;
    }
  } else if (main.columnHeaders) {
    p = main;
  }

  if (p == null) {
    return null;
  }
  p.slugValueNew = main.slugValueNew;

  let columns = p.columnHeaders
    ? p.columnHeaders.map((a) => {
        return {
          title: a,
          dataIndex: a,
          key: a,
          render: (itemR, record) => {
            if (itemR && itemR.answerValue && itemR.answerValue == "-") {
              return <p>-</p>;
            }

            if (itemR && itemR.answerValue) {
              return <p>{itemR.answerValue.answer}</p>;
            }
            if (itemR && !itemR.questionType && typeof itemR == "string") {
              return <h4>{itemR}</h4>;
            }
            if (itemR && itemR.questionType) {
              let subElem = (
                <Input style={{ width: "90%" }} placeholder={"Answer"} />
              );
              if (answers && answers.answers == true) {
                switch (itemR.questionType) {
                  case "FREE_TEXT":
                    itemR.freeText &&
                    itemR.freeText.textInputType == "SINGLE_LINE"
                      ? (subElem = (
                          <Input
                            style={{ width: "90%" }}
                            placeholder={"Answer"}
                          />
                        ))
                      : itemR.freeText &&
                          itemR.freeText.textInputType == "MULTI_LINE"
                        ? (subElem = (
                            <Input.TextArea
                              style={{ width: "90%" }}
                              placeholder={"Answer"}
                            />
                          ))
                        : (subElem = (
                            <Input
                              style={{ width: "90%" }}
                              placeholder={"Answer"}
                            />
                          ));
                    break;

                  case "NUMBER":
                    subElem = (
                      <InputNumber
                        style={{ width: "90%" }}
                        placeholder={"Answer"}
                      />
                    );
                    break;

                  case "DATE":
                    subElem = <DatePicker />;
                    break;

                  case "CHECK_BOX":
                    subElem = (
                      <Checkbox.Group style={{ width: "100%" }}>
                        <Row>
                          {itemR.checkboxList.map((m) => {
                            return (
                              <Col>
                                <Checkbox value={m.optionTitle}>
                                  {m.optionTitle}
                                </Checkbox>
                              </Col>
                            );
                          })}
                        </Row>
                      </Checkbox.Group>
                    );
                    break;

                  case "RADIO_BUTTON":
                    subElem = (
                      <Radio.Group
                        className="chatresponse-wrapper"
                        style={{ width: "100%" }}
                      >
                        {itemR.radioList.map((m) => {
                          return (
                            <Radio value={m.optionTitle}>{m.optionTitle}</Radio>
                          );
                        })}
                      </Radio.Group>
                    );
                    break;
                  default:
                    break;
                }
              } else {
                switch (itemR.questionType) {
                  case "FREE_TEXT":
                    itemR.freeText &&
                    itemR.freeText.textInputType == "SINGLE_LINE"
                      ? (subElem = "Single Line")
                      : itemR.freeText &&
                          itemR.freeText.textInputType == "MULTI_LINE"
                        ? (subElem = "Multi line")
                        : (subElem = "Single Line");
                    break;
                  case "NUMBER":
                    subElem = "Number";
                    break;
                  case "DATE":
                    subElem = "Date";
                    break;
                  case "CHECK_BOX":
                    subElem = "Multi select";
                    break;
                  case "RADIO_BUTTON":
                    subElem = "Single select";
                    break;
                  default:
                    break;
                }
              }

              return (
                <div>
                  {answers && answers.answers == true ? (
                    <Form.Item
                      style={{ marginBottom: "0px" }}
                      name={[p.slugValueNew, itemR.index, "answer"]}
                    >
                      {subElem}
                    </Form.Item>
                  ) : (
                    subElem
                  )}
                </div>
              );
            }
            return <p>abc</p>;
          },
        };
      })
    : [];

  if (p.rowHeaders) {
    columns.splice(0, 0, {
      title: "",
      dataIndex: "rowHeader",
      key: "a",
    });
  }

  let dataSource = p.table.map((a, i) => {
    let obj = new Object();

    a.map((c, j) => {
      if (c) {
        c.index = `${j}${i}`;
      }
      let colTitle = p.columnHeaders[j];
      obj[colTitle] = c;
    });
    if (p.rowHeaders && p.rowHeaders[i]) {
      obj["rowHeader"] = p.rowHeaders[i];
    }
    return obj;
  });
  // console.log("datasorce",dataSource)

  //   let arr=[],obj={}
  //   dataSource.length>0 && dataSource.map((val,ind)=>{
  //     obj["rowHeader"]=val.rowHeader
  // for (const [key, value] of Object.entries(val)) {

  //   if(key && value.answerValue!=null){
  //     if(key!="rowHeader"){
  //           obj[key]=value && value.answerValue &&value.answerValue.answer
  //     }

  //   }

  // }
  // console.log(obj)
  // arr.push(obj)
  // obj={}
  //   })

  //   let str=''

  //   arr.length>0 && arr.map((i,j)=>{
  //         for (const [key, value] of Object.entries(i)) {
  //           if(key=="rowHeader"){
  //            str+=value+'\n'
  //           }
  //           else{
  //            str+='\xa0\xa0'+key+' : '+value+'\n'
  //           }
  //         }

  //   })

  // return str;
  return (
    <Table
      size="small"
      dataSource={dataSource}
      columns={columns}
      pagination={false}
    />
  );
};

export {
  getDataFromDbForm,
  getSummaryFromData,
  getItemValidation,
  checkValidation,
  returnTable,
  returnFormattedDemodata,
  compareForUnsavedChanges,
  uploadToS3,
  checkConditions,
  getQuesSummeryForPrint,
};
